module.exports = __webpack_public_path__ + "static/media/thiru.bbb5e050.png";